import { render } from "./EditArea.vue?vue&type=template&id=8e2e382c&scoped=true"
import script from "./EditArea.vue?vue&type=script&lang=js"
export * from "./EditArea.vue?vue&type=script&lang=js"

import "./EditArea.vue?vue&type=style&index=0&id=8e2e382c&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e2e382c"]])

export default __exports__